// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"_1E_Pfd3gWVSF2c_6N1YZ3Q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPopover/OMPopover.scss
// module id = 1671
// module chunks = 0